var _circle, _path, _path2, _rect, _path3, _ellipse, _circle2, _circle3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransaksi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0E5F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0753 25.0307C22.2546 25.441 19.3139 26.5694 17.9461 27.0824C18.63 27.5953 20.2029 28.6211 21.0236 28.6211C21.8443 28.6211 25.4688 26.2275 27.1785 25.0307C26.1527 24.8597 23.8959 24.6204 23.0753 25.0307Z",
    fill: "#F0A390"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6398 25.0303C24.8192 25.8509 21.1946 26.74 19.4849 27.0819L20.5107 29.6465C21.7075 29.4755 24.4088 28.9284 25.6398 28.1078C27.1786 27.0819 29.2302 25.5432 29.2302 25.0303C29.2302 24.5174 26.6657 24.0045 25.6398 25.0303Z",
    fill: "#F5BCAE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.5681,
    height: 12.723,
    transform: "matrix(1 0 0 -1 10.2524 21.9531)",
    fill: "url(#paint0_linear_2296_6951)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9741 20.1363H13.4018C13.4222 20.0641 13.4332 19.9879 13.4332 19.9091C13.4332 19.4491 13.0602 19.0761 12.6001 19.0761C12.5213 19.0761 12.4451 19.087 12.3729 19.1074V12.0774C12.4451 12.0978 12.5213 12.1088 12.6001 12.1088C13.0602 12.1088 13.4332 11.7358 13.4332 11.2757C13.4332 11.1969 13.4222 11.1207 13.4018 11.0485H29.9741C29.9536 11.1207 29.9427 11.1969 29.9427 11.2757C29.9427 11.7358 30.3157 12.1088 30.7758 12.1088C30.8545 12.1088 30.9307 12.0978 31.003 12.0774V19.1074C30.9307 19.087 30.8545 19.0761 30.7758 19.0761C30.3157 19.0761 29.9427 19.4491 29.9427 19.9091C29.9427 19.9879 29.9536 20.0641 29.9741 20.1363ZM31.6088 19.9091V11.2757V11.0485V10.4427H31.003H30.7758H12.6001H12.3729H11.7671V11.0485V11.2757V19.9091V20.1363V20.7422H12.3729H12.6001H30.7758H31.003H31.6088V20.1363V19.9091Z",
    fill: "#438B4E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.34769,
    cy: 2.95354,
    rx: 2.34769,
    ry: 2.95354,
    transform: "matrix(1 0 0 -1 19.1888 18.6211)",
    fill: "#438B4E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.681587,
    cy: 0.681587,
    r: 0.681587,
    transform: "matrix(1 0 0 -1 14.1905 15.8945)",
    fill: "#438B4E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.681587,
    cy: 0.681587,
    r: 0.681587,
    transform: "matrix(1 0 0 -1 27.5193 15.8945)",
    fill: "#438B4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85769 20.3955C7.83333 20.3955 6.65245 23.102 6.31505 24.4553C4.79678 30.5452 14.4125 30.5447 17.9551 31.0522C21.4978 31.5596 25.0404 30.0372 26.0526 29.5297C27.0648 29.0223 31.1135 26.9924 30.1013 24.9625C29.0891 22.9326 27.0648 25.4702 24.5343 26.4852C22.0039 27.5001 16.4369 26.9924 16.4369 24.9625C16.4369 23.9476 19.4734 22.9326 20.4856 22.4251C21.4978 21.9177 22.51 20.3952 21.4978 19.3803C20.4856 18.3653 17.9552 20.3952 15.4247 20.9027C13.9359 21.2013 12.3881 20.3955 9.85769 20.3955Z",
    fill: "url(#paint1_linear_2296_6951)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2296_6951",
    x1: 11.2841,
    y1: 0,
    x2: 11.2841,
    y2: 16.4132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DC361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAE2C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2296_6951",
    x1: 13.2391,
    y1: 30.6468,
    x2: 17.815,
    y2: 19.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958828,
    stopColor: "#F3B8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransaksi);
export default __webpack_public_path__ + "static/media/icon-transaksi.4ca287e12b9e0a5464fad1e9ad11b0b1.svg";
export { ForwardRef as ReactComponent };